"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hash = void 0;
var Hash = /** @class */ (function () {
    function Hash() {
    }
    /**
     * Checks if the passed string equals the stored hash.
     *
     * @param key
     * @param hash
     */
    Hash.prototype.areHashesEqual = function (key, hash) {
        return __awaiter(this, void 0, void 0, function () {
            var storedItem;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isHashTimestampValid(key)) {
                            return [2 /*return*/, false];
                        }
                        storedItem = this.getHash(key);
                        if (!storedItem) {
                            return [2 /*return*/, false];
                        }
                        if (storedItem.hash === hash) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, this.createHash(hash)];
                    case 1:
                        // If not, check if we need to hash the compared string as well.
                        hash = _a.sent();
                        return [2 /*return*/, storedItem.hash === hash];
                }
            });
        });
    };
    /**
     * Store a hash with a specific key, for a specific time.
     *
     * Example, to store a hash for 30 days (2592000s)
     *
     * @example ```js
     * new Hash.storeHash('modal-opened', "This is the content we are hashing that defines if the modal is changes", 2592000)
     * ```
     *
     * @param {string} key The key to store the hash at
     * @param {string} hashTarget The data to hash.
     * @param {number} expiresIn The time to expire in. Defaults to 7 days.
     */
    Hash.prototype.storeHash = function (key, hashTarget, expiresIn) {
        if (expiresIn === void 0) { expiresIn = 604800; }
        return __awaiter(this, void 0, void 0, function () {
            var hash;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createHash(hashTarget)];
                    case 1:
                        hash = _a.sent();
                        window.localStorage.setItem(key, JSON.stringify({
                            hash: hash,
                            expiresAt: (new Date().getTime() / 1000) + expiresIn,
                        }));
                        return [2 /*return*/];
                }
            });
        });
    };
    Hash.prototype.createHash = function (hashTarget) {
        return crypto.subtle.digest('SHA-256', new TextEncoder().encode(hashTarget))
            .then(function (h) {
            var hexes = [];
            var view = new DataView(h);
            for (var i = 0; i < h.byteLength; i += 4) {
                hexes.push(('00000000' + view.getUint32(i).toString(16)).slice(-8));
            }
            return hexes.join('');
        });
    };
    Hash.prototype.deleteHash = function (key) {
        var item = this.storageObject.getItem(key);
        if (!item) {
            return;
        }
        window.localStorage.removeItem(key);
    };
    Hash.prototype.isHashTimestampValid = function (key) {
        var hashObject = this.getHash(key);
        if (!hashObject) {
            return false;
        }
        if (!hashObject.expiresAt) {
            return true;
        }
        var now = new Date().getTime() / 1000;
        var isExpired = hashObject.expiresAt <= now;
        if (isExpired) {
            this.deleteHash(key);
        }
        return !isExpired;
    };
    Hash.prototype.getHash = function (key) {
        var item = this.storageObject.getItem(key);
        if (!item) {
            return false;
        }
        return JSON.parse(item);
    };
    Object.defineProperty(Hash.prototype, "storageObject", {
        get: function () {
            return ('localStorage' in window) ? window.localStorage : new Storage();
        },
        enumerable: false,
        configurable: true
    });
    return Hash;
}());
exports.Hash = Hash;
var Storage = /** @class */ (function () {
    function Storage() {
        this.storage = new Map();
    }
    Storage.prototype.getItem = function (key) {
        return this.storage.get(key);
    };
    Storage.prototype.setItem = function (key, data) {
        this.storage.set(key, data);
    };
    Storage.prototype.removeItem = function (key) {
        this.storage.delete(key);
    };
    return Storage;
}());
exports.default = Hash;
//# sourceMappingURL=async-hash.js.map